import React from 'react';
import { APPLY_VERSION_CHOICES } from '../../../../components/GlobalJobMatching/GlobalJobMatchingVersioning/GlobalJobMatchingService';
import { Tooltip } from 'ps-design';
import './ApplyToJobsDropdown.scss';

interface ApplyToDropdownProps {
  dropdownItems: APPLY_VERSION_CHOICES[];
  onClick(item: APPLY_VERSION_CHOICES): void;
  className: string;
}

const CREATE_NEW_TEXT = 'This option will create new matches for existing priced jobs and a new pricing for non-priced jobs. If the match already exists on a priced job, it will not be overwritten.';
const OVERWRITE_EXISTING_TEXT = 'If a match to the same survey/survey job already exists, but the data cut is different, the new data cut match will be used. It only impacts surveys included in the version rules. Any match not included in the version rules is unaffected.';
const OVERWRITE_ALL_AND_PRESERVE_TEXT = 'This option will remove all of the matches from the jobs included in the version rules and apply the new matches where applicable. Any matches from the jobs included in the version rules where no new matches can be made will be preserved.';

function ApplyToJobsDropdown(props: ApplyToDropdownProps): React.ReactElement {

  const getHoverText = (item: APPLY_VERSION_CHOICES): string => {
    if (item === APPLY_VERSION_CHOICES.CREATE_NEW) {
      return CREATE_NEW_TEXT;
    } else if (item === APPLY_VERSION_CHOICES.OVERWRITE_EXISTING) {
      return OVERWRITE_EXISTING_TEXT;
    } else if (item === APPLY_VERSION_CHOICES.OVERWRITE_ALL_AND_PRESERVE) {
      return OVERWRITE_ALL_AND_PRESERVE_TEXT;
    }
    return 'test';
  }

  return (
    <div className={props.className}>
      {props.dropdownItems?.map((item, index) => {
        return (
          <div key={index} className="apply-to-jobs__dropdown-item dropdown__item" onClick={() => props.onClick(item)}>
            <Tooltip
              tooltipText={item}
              position='left'
              hoverText={getHoverText(item)}
            />
          </div>
        );
      })}
    </div>
  );
}

export default ApplyToJobsDropdown;
